module.exports = __webpack_public_path__ + "img/empty.8bcfacd8.png";